import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, Star, ArrowLeft } from 'lucide-react';
import { useEmpresaPublica } from '@/hooks/useMarketplace';
import { ContactoCTA } from '@/components/marketplace/ContactoCTA';

export default function EmpresaPublica() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data, isLoading } = useEmpresaPublica(id);

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-muted-foreground" /></div>;
  }
  if (!data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background p-4 text-center">
        <p className="text-muted-foreground">{t('marketplace.notFound')}</p>
        <Link to="/empresas" className="ow-btn ow-btn--outline">{t('marketplace.back')}</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center gap-3 px-4 h-14 border-b border-border">
        <Link to="/empresas" aria-label={t('marketplace.back')}><ArrowLeft className="h-5 w-5" /></Link>
        <span className="font-bold truncate">{data.nome}</span>
      </header>
      <main className="max-w-2xl mx-auto p-4 flex flex-col gap-5">
        <div className="flex items-center gap-4">
          {data.logo_url
            ? <img src={data.logo_url} alt="" className="h-16 w-16 rounded-xl object-cover" />
            : <div className="h-16 w-16 rounded-xl bg-muted flex items-center justify-center text-xl font-bold">{(data.nome[0] ?? '?').toUpperCase()}</div>}
          <div>
            <h1 className="text-xl font-bold">{data.nome}</h1>
            {data.rating_total > 0 && (
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                <Star className="h-4 w-4 fill-current" /> {data.rating_media} · {t('marketplace.reviews', { count: data.rating_total })}
              </div>
            )}
          </div>
        </div>

        {data.descricao_publica && <p className="text-sm">{data.descricao_publica}</p>}

        {data.categorias.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {data.categorias.map((c) => <span key={c.slug} className="status-pill text-xs">{c.nome}</span>)}
          </div>
        )}

        {data.cidades.length > 0 && (
          <div>
            <h2 className="text-sm font-bold mb-1">{t('marketplace.cities')}</h2>
            <p className="text-sm text-muted-foreground">{data.cidades.join(' · ')}</p>
          </div>
        )}

        {data.servicos.length > 0 && (
          <div>
            <h2 className="text-sm font-bold mb-1">{t('marketplace.services')}</h2>
            <ul className="text-sm text-muted-foreground list-disc pl-5">
              {data.servicos.map((s) => <li key={s}>{s}</li>)}
            </ul>
          </div>
        )}

        <ContactoCTA orgId={data.id} />
      </main>
    </div>
  );
}
